"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("settings-ui-sdk/Integrations/actions");

var _selectors = require("./selectors");

var _reduxObservable = require("redux-observable");

var _API = _interopRequireDefault(require("./API"));

var fetchInstalledIntegrations = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getInstalledIntegrations,
  initiatingActionType: _actions.IntegrationsActionTypes.FETCH_INSTALLED_INTEGRATIONS,
  requestStatusSelector: _selectors.getFetchInstalledRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchInstalled
}));

var _default = (0, _reduxObservable.combineEpics)(fetchInstalledIntegrations);

exports.default = _default;
module.exports = exports.default;